module.exports = __webpack_public_path__ + "static/media/Pernod Ricard.f23b78e4.png";